module.exports = __webpack_public_path__ + "img/x5.a28beb09.jpg";